// Copied from coulomb-commons-ui soh-band-migration 0.1.0 (src/components/chartInteraction.js).
// Hover highlight / dim rule. Pure -- no DOM, no React.
//
// Nodes never dim. A ribbon is at full opacity unless something is hovered; while
// hovering it stays at 1 if it is the hovered ribbon or the hovered node is one of
// its endpoints (one hop only), otherwise it drops to dimOpacity. (The original's
// last-column tile filter is not copied: there are no stat tiles here.)
//
// `hover` is { kind: 'node', id } | { kind: 'edge', id } | null, where an edge id
// is `${sourceNodeId}>${targetNodeId}` (see buildSankeyGraph).

/** @param {{ id: string, source: string, target: string }} flow */
export function flowOpacity(flow, { hover, dimOpacity }) {
  if (!hover) return 1;
  const hit =
    (hover.kind === "edge" && hover.id === flow.id) ||
    (hover.kind === "node" && (hover.id === flow.source || hover.id === flow.target));
  return hit ? 1 : dimOpacity;
}
